import { render, staticRenderFns } from "./toolbarTask.vue?vue&type=template&id=078bd4e4&scoped=true"
import script from "./toolbarTask.vue?vue&type=script&lang=js"
export * from "./toolbarTask.vue?vue&type=script&lang=js"
import style0 from "./toolbarTask.vue?vue&type=style&index=0&id=078bd4e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078bd4e4",
  null
  
)

export default component.exports